import * as React from 'react'

export const throwConfettiOnClick = (
  e: React.MouseEvent<HTMLButtonElement>
): void => {
  const x = e.clientX / document.documentElement.clientWidth
  const y = e.clientY / document.documentElement.clientHeight
  window.throwConfetti(x, y)
}
